/* Customer skills page: the list shares the table of the data page; the editor is a plain SKILL.md text field. */
.secondaryHeaderButton {
  min-height: 44px;
  padding: 0 16px;
  border: none;
  border-radius: var(--radius);
  background: var(--surface-2);
  color: var(--text);
  font: inherit;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

.nameCell {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.badge {
  background: var(--warning-soft);
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 700;
}

.description {
  max-width: 420px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.actions {
  display: flex;
  justify-content: flex-end;
}

.editButton {
  min-height: 44px;
  padding: 0 14px;
  border: none;
  border-radius: var(--radius);
  background: transparent;
  color: var(--link);
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.editButton:hover {
  background: var(--surface-2);
}

.editor {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  max-width: 900px;
}

.editorTitle {
  margin: 0;
  font-size: 22px;
  overflow-wrap: anywhere;
}

.label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--muted);
}

.textarea {
  min-height: 420px;
  padding: 12px 14px;
  border: none;
  border-radius: var(--radius);
  background: var(--surface-2);
  color: var(--text);
  font-family: var(--mono);
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0;
  text-transform: none;
  resize: vertical;
}

.hint {
  margin: 0;
  color: var(--muted);
  line-height: 1.5;
}

.problems {
  margin: 0;
  padding: var(--space-2) 16px;
  background: var(--danger-soft);
  border-radius: var(--radius);
  line-height: 1.5;
}

.problems ul {
  margin: 4px 0 0;
  padding-left: 20px;
}

.editorActions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
